export default "__VITE_ASSET__4aaacec2__"